import { css } from '@emotion/react'

export const rowButtonStyles = css`
    width: 100%;
`
